import { useMemo } from "react";
import { TabbedWorkItems } from "./TabbedWork";

type WorkTab = {
  entityTypes: string | string[];
  label?: string;
};
export const generateWorkTabs = (
  orgId: string,
  entityUuid: string,
  workTabs: WorkTab[],
  pagingSize?: number
): TabbedWorkItems[] => {
  const allTabs = {
    name: "All",
    aggregate: true,
    search: {
      orgId,
      entityUuid,
      pagingSize,
      types: workTabs.flatMap((workTab) => workTab.entityTypes),
    },
  };
  const tabs = workTabs.map((workTab) => {
    const label = extractLabel(workTab);
    const types: string[] = Array.isArray(workTab.entityTypes)
      ? workTab.entityTypes
      : [workTab.entityTypes];
    return {
      name: label,
      search: {
        orgId,
        entityUuid,
        pagingSize,
        types: types,
      },
    };
  });
  return [allTabs, ...tabs];
};

export function useWorkTabs(...args: Parameters<typeof generateWorkTabs>) {
  return useMemo(() => generateWorkTabs(...args), [args]);
}

const extractLabel = (workTab: WorkTab): string => {
  if (workTab.label) {
    return workTab.label;
  }
  if (typeof workTab.entityTypes === "string") {
    return `${workTab.entityTypes}s`;
  }
  return "All kinds of stuff.";
};
